// extracted by mini-css-extract-plugin
export default {"pageWrapper":"OemPage_pageWrapper__Ryuul","centerWrapper":"OemPage_centerWrapper__QHtoB","amount":"OemPage_amount__ew7fj","currency":"OemPage_currency__d56GS"};